import React, { useState, useContext, useEffect, useCallback, useRef } from 'react'
import {
  AddButton, AddButtonImg, AddButtonText, AddProductContainer, Button, Card,
  CollapsibleHeader, FirstText, FormGrid, FormGroup, InfoLink, InfoName, InfoValue, InputText,
  Label, MoreInformation, SecondText, Select, Separator, ShortLabel, ShortLabelText,
  SeparatorImg, Summary, SummaryItem, SummaryLabel, SummaryValue, KitSummaryLabel, Title,
  ActionButtonsRow, InfoPopoverWrapper, OptionAddRow, OptionSelectRow,
  ProductFieldsRow, KitSummaryRow, KitTrashImg, ActionIconImg,
  SwitchBox, SwitchInput, SwitchSlider, Textarea,
  KitContainer, KitHeader, SubProductCard,
  ModalOverlay, ModalWrapper, CenteredButtonsRow, ActionOutlineButton, ActionSolidButton,
  RoundTrashButton, RoundCollapseButton, ItemsListContainer, CardProductDiv, CardActionsDiv,
} from './style'
import { ChevronDown, ChevronUp, Info, Plus, RefreshCw, Trash2 } from 'lucide-react'
import plus from '../../../../assets/fashion/TableFashionHeader/plus.svg'
import rectangle from '../../../../assets/fashion/TableFashionHeader/rectangle.svg'
import trash from '../../../../assets/fashion/TableFashionHeader/trash.svg'
import editPen from '../../../../assets/fashion/TableFashionHeader/edit-pen.svg'
import { useOutletContext, useParams } from 'react-router-dom'
import axios from '../../../../config/axios'
import { ActionsDiv, ProductDiv, ProductShort } from '../AddProductForm/style'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'
import AttachmentManager, { ExistingAttachment } from '../../../../components/AttachmentManager'
import { downloadRemoteFile } from '../../../../utils/downloadRemoteFile'
import VendorSelect from '../SelectItem/VendorSelect'
import CompanySelect from '../SelectItem/CompanySelect'
import AddProductForm from '../AddProductForm'
import InfiniteSelect from '../../../../components/InfiniteSelect'
import ApiService from '../../../../services/ApiService'
import { paymentMethodLabel } from '../../../../utils/paymentMethodLabels'

const compareSizes = (a: string, b: string): number => {
  const isNumA = /^\d+$/.test(a);
  const isNumB = /^\d+$/.test(b);

  if (isNumA && isNumB) {
    return Number(a) - Number(b);
  }
  if (isNumA && !isNumB) {
    return -1;
  }
  if (!isNumA && isNumB) {
    return 1;
  }

  const textOrder = [
    'PP', 'P', 'M', 'G', 'GG', 'XL', 'XLL',
    'G1', 'G2', 'G3', 'G4',
    'TAMANHO ÚNICO', 'ÚNICO', 'U'
  ];

  const normA = a.trim().toUpperCase();
  const normB = b.trim().toUpperCase();

  const idxA = textOrder.indexOf(normA);
  const idxB = textOrder.indexOf(normB);

  if (idxA !== -1 && idxB !== -1) {
    return idxA - idxB;
  }
  if (idxA !== -1 && idxB === -1) {
    return -1;
  }
  if (idxA === -1 && idxB !== -1) {
    return 1;
  }

  return a.localeCompare(b);
};

const ORDERS_URL = `${process.env.REACT_APP_GATEWAY_BASE_URL}/steel-orders`
const UPLOAD_URL = `${process.env.REACT_APP_GATEWAY_BASE_URL}/steel-orders/order/upload-attachment`
const FILE_SIZE_LIMIT = 200 * 1024 * 1024

interface FashionOrderProductItemInput { colorId: number; size: string; quantity: number }
type SizeQuantities = { [size: string]: number }

interface ProductApiData {
  fashionProductId?: number
  discount: number | null
  sellingPrice?: number | null
  totalItems: number
  subtotal: number
  items: FashionOrderProductItemInput[]
  fashionOrderId?: number
  fashionProduct?: {
    id: number; name: string; price: number; size: string[]
    group: { id: number; name?: string; family?: { id: number; name?: string; collectionId?: number } }
  }
  colorCount?: number
  colors?: string[]
  family?: { id: number; name?: string; familyId?: number }
  group?: { id: number; name?: string }
  name?: string
  price?: number
  selectedColors?: number[]
  discountValue?: number
  sizeQuantities?: SizeQuantities
  kitIndex?: number | null
  isKitIntent?: boolean
}

interface CompanyItemType { id: number; companyName: string }
interface UserItemType { id: number; name: string }

type FormContent = {
  handleSave?: React.MutableRefObject<() => void>
  handleEditSave?: React.MutableRefObject<() => Promise<void>>
  setIsSaving?: (val: boolean) => void
}

import styled from 'styled-components'

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`

const InstallmentsTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const InstallmentRow = styled.div`
  display: grid;
  grid-template-columns: 48px 1fr 1fr 48px;
  gap: 16px;
  align-items: center;
`

const HeaderRow = styled(InstallmentRow)`
  & > span {
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    color: #303030;
  }
`

const NumberCell = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  color: #696969;
  text-align: center;
`

const RemoveButton = styled.button`
  background: none;
  border: none;
  color: #F87171;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;

  &:hover {
    color: #DC2626;
  }
`

const EmptyMessage = styled.p`
  font-family: 'Inter', sans-serif;
  color: #696969;
  font-size: 14px;
`

const SummaryLine = styled.div<{ mismatch?: boolean }>`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: ${props => (props.mismatch ? '#F87171' : '#303030')};
  font-weight: 700;
`

const CircularCollapseIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #0090D3;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #F0F9FF;
  }

  svg {
    width: 16px;
    height: 16px;
    color: #0090D3;
  }
`

const cleanCurrency = (value: any): number => {
  const num = Number(String(value || '').replace(/[^0-9,-]+/g, '').replace(',', '.'))
  return isNaN(num) ? 0 : num
}

const centsDigitsToReais = (value: unknown): number => {
  const digits = String(value ?? '').replace(/\D/g, '')
  if (!digits) return 0
  return Number(digits) / 100
}

const formatCurrency = (value: number): string =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).format(value)

const formatCentDigitsForInput = (value: unknown): string => {
  if (value === null || value === undefined || value === '') return ''
  const digits = String(value).replace(/\D/g, '')
  if (!digits) return ''
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(digits) / 100)
}

const formatDate = (iso: string | null | undefined): string =>
  iso ? iso.substring(0, 10) : ''

const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${Math.round((bytes / Math.pow(k, i)) * 100) / 100} ${sizes[i]}`
}

const getSafeValue = (value: any): string => {
  if (value === null || value === undefined) return '-'
  if (typeof value === 'object') return ('name' in value ? value.name : null) || '-'
  return String(value) || '-'
}

const countColors = (product: ProductApiData): number => {
  if (product.colorCount && product.colorCount > 0) return product.colorCount
  if (product.items?.length) return new Set(product.items.map((i) => i.colorId)).size
  return product.colors?.length ?? 0
}

const uploadFileToGeneralFiles = async (file: File): Promise<number> => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('title', file.name)
  const { data } = await axios.post<{ id: number }>(`${UPLOAD_URL}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data.id
}

const RegisterFashionOrder: React.FC = () => {
  const { orderId } = useParams<{ orderId?: string }>()
  const isEditing = !!orderId

  const outletContext = useOutletContext<FormContent>()
  const { setFeedback } = useContext(FeedbackContext)
  const formTopRef = useRef<HTMLDivElement>(null)

  const [loading, setLoading] = useState(isEditing)
  const [isDetailsOpen, setIsDetailsOpen] = useState(true)
  const [isInformationOpen, setIsInformationOpen] = useState(false)
  const [isClientInformationOpen, setIsClientInformationOpen] = useState(false)
  const [isSellerInfoOpen, setIsSellerInfoOpen] = useState(false)

  const [addedProducts, setAddedProducts] = useState<ProductApiData[]>([])
  const [editingProductIndex, setEditingProductIndex] = useState<number | null>(null)
  const [productToEdit, setProductToEdit] = useState<ProductApiData | null>(null)
  const [openProductIndex, setOpenProductIndex] = useState<number | null>(null)

  const [kitCount, setKitCount] = useState(0)
  const [showAddProductForSection, setShowAddProductForSection] = useState<'standalone' | number | null>(null)
  const [openKits, setOpenKits] = useState<{ [key: number]: boolean }>({})

  const [shippingOptions, setShippingOptions] = useState(['CIF', 'FOB', 'Cortesia'])
  const [paymentOptions, setPaymentOptions] = useState(['30 dias', '30/60 dias', '30/60/90 dias', 'A vista'])
  const [newShippingType, setNewShippingType] = useState('')
  const [newPaymentCondition, setNewPaymentCondition] = useState('')
  const [isAddingPayment, setIsAddingPayment] = useState(false)
  const [isAddingShipping, setIsAddingShipping] = useState(false)

  const [selectedFiles, setSelectedFiles] = useState<File[]>([])
  const [existingAttachments, setExistingAttachments] = useState<ExistingAttachment[]>([])
  const [existingFileIds, setExistingFileIds] = useState<number[]>([])
  const [removedFileIds, setRemovedFileIds] = useState<number[]>([])
  const [isKitMode, setIsKitMode] = useState(false);

  const [isShippingSectionOpen, setIsShippingSectionOpen] = useState(true)
  const [isPaymentSectionOpen, setIsPaymentSectionOpen] = useState(true)
  const [isItemsSectionOpen, setIsItemsSectionOpen] = useState(true)
  const [paymentMethods, setPaymentMethods] = useState<{ id: number; name: string }[]>([])
  const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState<number | null>(null)
  const [installments, setInstallments] = useState<any[]>([])
  const isInitialLoad = useRef(true)

  const [formState, setFormState] = useState({
    supplier: { id: 0, companyName: '' } as CompanyItemType,
    seller: { id: 0, name: '' } as UserItemType,
    company: { id: 0, companyName: '' } as CompanyItemType,
    carrier: { id: 0, companyName: '' } as CompanyItemType,
    orderType: '',
    orderTypeObj: null as { id: number; name: string } | null,
    representative: null as { id: number; name: string } | null,
    orderSituation: null as { id: number; name: string } | null,
    generalClass: null as { id: number; name: string } | null,
    billingDate: '',
    clientOrderNumber: '',
    sellingPrice: '',
    paymentCondition: null as { id: number; name: string } | null,
    shippingType: null as { id: number; name: string } | null,
    trackingCode: '',
    orderDate: new Date().toISOString().split('T')[0],
    deliveryDate: '',
    criticalAnalysis: false,
    criticalAnalysisDesc: '',
    extraInformation: '',
    quantityItems: '0', quantityPieces: '0', totalCost: 'R$ 0,00',
    deliveryTime: '', shippingCost: '', maximumBillingAmount: '',
  })

  const setField = (field: string, value: any) =>
    setFormState((prev) => ({ ...prev, [field]: value }))

  const normalizeProductData = useCallback((product: any): ProductApiData => {
    const sizeQuantities: SizeQuantities = {}
    const items = [...(product.items || [])] as FashionOrderProductItemInput[]
    items.sort((a, b) => compareSizes(a.size, b.size))
    items.forEach((item: FashionOrderProductItemInput) => {
      if (item.size && item.quantity !== undefined)
        sizeQuantities[item.size] = (sizeQuantities[item.size] || 0) + Number(item.quantity)
    })
    const totalItems = Object.values(sizeQuantities).reduce((sum, qty) => sum + qty, 0)
    const subtotal = product.subtotal ?? totalItems * (product.fashionProduct?.price || 0)
    const colorCount = product.colorCount || new Set(items.map((i: any) => i.colorId)).size

    return {
      ...product,
      sizeQuantities,
      totalItems,
      subtotal,
      colorCount,
      items,
      kitIndex: product.kitIndex !== undefined ? product.kitIndex : null,
    }
  }, [])

  useEffect(() => {
    if (!isEditing) return
    const loadOrder = async () => {
      setLoading(true)
      try {
        const { data } = await axios.get(`${ORDERS_URL}/order/${orderId}`)

        let sellerObj = {
          id: data.sellerId || 0,
          name: data.sellerDetails?.name || data.seller || '',
          email: data.sellerDetails?.email || '',
          Profile: data.sellerDetails?.Profile || null,
          profile: data.sellerDetails?.profile || null,
          profileId: data.sellerDetails?.profileId || null,
        }

        if (data.sellerId) {
          try {
            const sellerRes = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/user/${data.sellerId}`)
            if (sellerRes.data) {
              sellerObj = {
                id: data.sellerId,
                name: sellerRes.data.name || sellerObj.name,
                email: sellerRes.data.email || sellerObj.email,
                Profile: sellerRes.data.Profile || sellerRes.data.profile || sellerObj.Profile,
                profile: sellerRes.data.Profile || sellerRes.data.profile || sellerObj.profile,
                profileId: sellerRes.data.profileId || sellerObj.profileId,
              }
            }
          } catch (e) {
            console.warn(`Não foi possível buscar vendedor ${data.sellerId} durante edição:`, e)
          }
        }

        let supplierObj = { id: Number(data.supplierId), companyName: data.supplierDetails?.name || data.supplier || '' }
        if (data.supplierId) {
          try {
            const supplierRes = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/companies/${data.supplierId}`)
            if (supplierRes.data) {
              supplierObj = supplierRes.data
            }
          } catch (e) {
            console.warn(`Não foi possível buscar fornecedor ${data.supplierId} durante edição:`, e)
          }
        }

        let companyObj = { id: Number(data.clientId), companyName: data.clientDetails?.name || data.client || '' }
        if (data.clientId) {
          try {
            const companyRes = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/companies/${data.clientId}`)
            if (companyRes.data) {
              companyObj = companyRes.data
            }
          } catch (e) {
            console.warn(`Não foi possível buscar cliente ${data.clientId} durante edição:`, e)
          }
        }

        setFormState({
          supplier: supplierObj,
          seller: sellerObj,
          company: companyObj,
          carrier: data.carrier ? { id: Number(data.carrier.id), companyName: data.carrier.companyName || '' } : { id: 0, companyName: '' },
          orderType: data.orderType?.name || '',
          orderTypeObj: data.orderType ? { id: data.orderTypeId, name: data.orderType.name || '' } : null,
          representative: data.representative ? { id: data.representativeId, name: data.representative.name || '' } : null,
          orderSituation: data.orderSituation ? { id: data.orderSituationId, name: data.orderSituation.name || '' } : null,
          generalClass: data.generalClass ? { id: data.generalClassId, name: data.generalClass.name || '' } : null,
          billingDate: data.billingDate ? formatDate(data.billingDate) : '',
          clientOrderNumber: data.clientOrderNumber ? String(data.clientOrderNumber) : '',
          sellingPrice: data.sellingPrice ? String(Math.round(Number(data.sellingPrice) * 100)) : '',
          paymentCondition: typeof data.paymentCondition === 'object' && data.paymentCondition !== null
            ? data.paymentCondition
            : (data.paymentTerm ? { id: 0, name: data.paymentTerm } : null),
          shippingType: typeof data.shippingType === 'object' && data.shippingType !== null
            ? data.shippingType
            : (data.shippingType ? { id: 0, name: data.shippingType } : null),
          trackingCode: data.trackingCode || '',
          orderDate: formatDate(data.orderDate) || new Date().toISOString().split('T')[0],
          deliveryDate: formatDate(data.finalDateOfDelivery || data.startDateOfDelivery),
          criticalAnalysis: data.criticalAnalysis || false,
          criticalAnalysisDesc: data.criticalAnalysisDesc || '',
          extraInformation: data.extraInfo || data.extraInformation || '',
          quantityItems: data.quantityItems || '0',
          quantityPieces: data.quantityPieces || '0',
          totalCost: `R$ ${Number(data.totalCost || 0).toFixed(2).replace('.', ',')}`,
          deliveryTime: data.deliveryTime || '',
          shippingCost:
            data.shippingValue != null && data.shippingValue !== ''
              ? String(Math.round(Number(data.shippingValue) * 100))
              : data.shippingCost != null && data.shippingCost !== ''
                ? String(Math.round(Number(data.shippingCost) * 100))
                : '',
          maximumBillingAmount: data.maximumBillingAmount || '',
        })

        const attachments: ExistingAttachment[] = (data.attachments || []).map((a: any) => ({
          id: a.id,
          originalName: a.originalName || a.title || a.fileName || 'Arquivo',
          filePath: a.fileUrl || a.filePath,
          fileSize: a.fileSize,
          mimeType: a.mimeType,
        }))
        setExistingAttachments(attachments)
        setExistingFileIds(attachments.map((a) => a.id))
        setRemovedFileIds([])

        const products = (data.items || [])
          .filter((item: any) => item.itemType === 'PRODUCT')
          .map((item: any) => {
            let extra: any = {}
            try { extra = item.extraInfo ? JSON.parse(item.extraInfo) : {} } catch { /* ignore */ }

            const P = item.Product as { Family?: { id?: number; name?: string }; family?: { id?: number; name?: string } } | undefined
            const famRel = P?.Family || P?.family
            const famId = Number(extra.familyId ?? famRel?.id ?? 0)
            const famName = String(extra.familyName || famRel?.name || '').trim()

            return normalizeProductData({
              fashionProductId: item.productId,
              fashionProduct: {
                id: item.productId,
                name: extra.fashionProductName || item.Product?.name || '',
                price: extra.fashionProductPrice || item.Product?.price || 0,
                group: {
                  id: extra.groupId || item.Product?.group?.id,
                  name: extra.groupName || item.Product?.group?.name || '',
                  family: {
                    id: famId,
                    name: famName,
                    collectionId: extra.collectionId,
                  },
                },
              },
              family: famName ? { id: famId, name: famName } : undefined,
              discount: item.descount || 0,
              sellingPrice: item.sellingPrice || null,
              totalItems: item.quantity || 0,
              subtotal: item.priceKg || 0,
              items: extra.fashionItems || [],
              colorCount: extra.colorCount || 0,
              colors: extra.colors || [],
              selectedColors: extra.selectedColors || [],
              kitIndex: item.kitIndex !== undefined ? item.kitIndex : null,
            })
          })

        setAddedProducts(products)

        const maxKitIndex = products.reduce((max: number, p: ProductApiData) => {
          if (p.kitIndex !== null && p.kitIndex !== undefined && p.kitIndex > max) return p.kitIndex
          return max
        }, -1)
        setKitCount(maxKitIndex >= 0 ? maxKitIndex + 1 : 0)

        const pmRelation = data.OrderPaymentMethod?.[0] || data.orderPaymentMethod?.[0] || data.paymentMethods?.[0] || data.orderPaymentMethods?.[0];
        if (pmRelation) {
          const pmId = pmRelation.paymentMethodId || pmRelation.id || pmRelation.paymentMethod?.id || pmRelation.PaymentMethod?.id;
          if (pmId) {
            setSelectedPaymentMethodId(Number(pmId));
          } else {
            setSelectedPaymentMethodId(null);
          }
        } else {
          setSelectedPaymentMethodId(null);
        }

        const loadedInstallments = (data.OrderInstallment || []).map((inst: any) => ({
          id: inst.id,
          numero: inst.numero,
          valor: Number(inst.valor || 0),
          vencimento: formatDate(inst.vencimento),
          diasOffset: inst.diasOffset ?? 0,
          comissaoAtiva: Boolean(inst.comissaoAtiva),
        }));
        setInstallments(loadedInstallments);
        isInitialLoad.current = false;

      } catch (error) {
        console.error('Erro ao buscar o pedido:', error)
      }
      setLoading(false)
    }
    loadOrder()
  }, [orderId, isEditing, normalizeProductData])

  const fetchOrderTypes = useCallback(async (limit: number, offset: number, search?: string) => {
    const page = Math.floor(offset / limit) + 1;
    const response = await ApiService.steelOrders.getOrderTypes({ page, limit, search });
    return Array.isArray(response.data) ? response.data : (response.data?.data ?? []);
  }, []);

  const createOrderTypeOption = useCallback(async (name: string) => {
    const response = await ApiService.steelOrders.createOrderType({ name });
    return response.data;
  }, []);

  const fetchRepresentatives = useCallback(async (limit: number, offset: number, search?: string) => {
    const page = Math.floor(offset / limit) + 1;
    const response = await ApiService.steelOrders.getRepresentatives({ page, limit, search });
    return Array.isArray(response.data) ? response.data : (response.data?.data ?? []);
  }, []);

  const createRepresentativeOption = useCallback(async (name: string) => {
    const response = await ApiService.steelOrders.createRepresentative({ name });
    return response.data;
  }, []);

  const fetchOrderSituations = useCallback(async (limit: number, offset: number, search?: string) => {
    const page = Math.floor(offset / limit) + 1;
    const response = await ApiService.steelOrders.getOrderSituations({ page, limit, search });
    return Array.isArray(response.data) ? response.data : (response.data?.data ?? []);
  }, []);

  const createOrderSituationOption = useCallback(async (name: string) => {
    const response = await ApiService.steelOrders.createOrderSituation({ name });
    return response.data;
  }, []);

  const fetchGeneralClasses = useCallback(async (limit: number, offset: number, search?: string) => {
    const page = Math.floor(offset / limit) + 1;
    const response = await ApiService.steelOrders.getGeneralClasses({ page, limit, search });
    return Array.isArray(response.data) ? response.data : (response.data?.data ?? []);
  }, []);

  const createGeneralClassOption = useCallback(async (name: string) => {
    const response = await ApiService.steelOrders.createGeneralClass({ name });
    return response.data;
  }, []);

  const deleteOrderTypeOption = useCallback(async (id: any) => {
    await ApiService.steelOrders.deleteOrderType(Number(id));
  }, []);

  const deleteRepresentativeOption = useCallback(async (id: any) => {
    await ApiService.steelOrders.deleteRepresentative(Number(id));
  }, []);

  const deleteOrderSituationOption = useCallback(async (id: any) => {
    await ApiService.steelOrders.deleteOrderSituation(Number(id));
  }, []);

  const deleteGeneralClassOption = useCallback(async (id: any) => {
    await ApiService.steelOrders.deleteGeneralClass(Number(id));
  }, []);

  useEffect(() => {
    if (isEditing) return;
    const fetchMatrixCompany = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/companies`, {
          params: { isMain: 'true' }
        });
        const data = Array.isArray(response.data) ? response.data : response.data.data;
        if (data && data.length > 0) {
          const matriz = data.find((c: any) => {
            const cnpjClean = c.cnpj?.replace(/\D/g, '') || '';
            return cnpjClean.slice(8, 12) === '0001';
          });
          if (matriz) {
            setFormState((prev) => ({
              ...prev,
              supplier: {
                id: matriz.id,
                companyName: matriz.companyName || matriz.name || '',
                cnpj: matriz.cnpj,
                cpf: matriz.cpf,
                city: matriz.city,
                state: matriz.state,
                contacts: matriz.contacts
              } as any
            }));
          } else {
            setFormState((prev) => ({
              ...prev,
              supplier: {
                id: data[0].id,
                companyName: data[0].companyName || data[0].name || '',
                cnpj: data[0].cnpj,
                cpf: data[0].cpf,
                city: data[0].city,
                state: data[0].state,
                contacts: data[0].contacts
              } as any
            }));
          }
        }
      } catch (error) {
        console.error('Erro ao buscar empresa matriz:', error);
      }
    };
    fetchMatrixCompany();
  }, [isEditing]);

  useEffect(() => {
    const totalPieces = addedProducts.reduce((sum, p) => {
      const pieces = p.sizeQuantities
        ? Object.values(p.sizeQuantities).reduce((s, q) => s + q, 0)
        : p.totalItems || 0
      return sum + pieces
    }, 0)
    const totalCost = addedProducts.reduce((sum, p) => sum + (p.subtotal || 0), 0)
    const shippingVal = Number(formState.shippingCost || 0) / 100
    const finalTotal = totalCost + shippingVal

    setFormState((prev) => ({
      ...prev,
      quantityItems: String(addedProducts.length),
      quantityPieces: String(totalPieces),
      totalCost: formatCurrency(finalTotal),
    }))
  }, [addedProducts, formState.shippingCost])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/steel-orders/select-in-order/payment-methods`)
      .then((res) => setPaymentMethods(res.data ?? []))
      .catch((err) => console.error(err))
  }, [])

  useEffect(() => {
    if (isEditing) return
    setSelectedPaymentMethodId(null)
    setInstallments([])
    isInitialLoad.current = true
  }, [isEditing])

  const parseConditionToOffsets = (name?: string): number[] => {
    if (!name) return [0]
    const normalized = name.trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
    if (normalized.includes('vista')) return [0]
    const offsets = name
      .split('/')
      .map(part => parseInt(part.replace(/\D/g, ''), 10))
      .filter(num => !isNaN(num))
    return offsets.length ? offsets : [0]
  }

  const addDays = (isoDate: string | undefined, days: number): string => {
    const base = isoDate ? new Date(`${isoDate}T00:00:00`) : new Date()
    if (isNaN(base.getTime())) return ''
    base.setDate(base.getDate() + days)
    return base.toISOString().slice(0, 10)
  }

  const buildInstallments = (total: number, offsets: number[], baseDate?: string) => {
    const count = offsets.length || 1
    const base = Math.round((total / count) * 100) / 100
    return offsets.map((offset, index) => {
      const isLast = index === count - 1
      const valor = isLast ? Math.round((total - base * (count - 1)) * 100) / 100 : base
      return {
        numero: index + 1,
        valor,
        vencimento: addDays(baseDate, offset),
        diasOffset: offset,
        comissaoAtiva: false,
      }
    })
  }

  useEffect(() => {
    if (isEditing && isInitialLoad.current) return
    if (!formState.paymentCondition?.name) {
      setInstallments([])
      return
    }

    const totalItemsCost = addedProducts.reduce((sum, p) => sum + (p.subtotal || 0), 0)
    const shippingVal = Number(formState.shippingCost || 0) / 100
    const totalOrder = totalItemsCost + shippingVal

    const offsets = parseConditionToOffsets(formState.paymentCondition.name)
    const baseDate = formState.deliveryDate || new Date().toISOString().slice(0, 10)
    const generated = buildInstallments(totalOrder, offsets, baseDate)
    setInstallments(generated)
  }, [formState.paymentCondition, addedProducts, formState.shippingCost, formState.deliveryDate, isEditing])

  const handleUpdateInstallment = (index: number, fieldsToUpdate: Partial<any>) => {
    setInstallments(prev => {
      const next = [...prev]
      next[index] = { ...next[index], ...fieldsToUpdate }
      return next
    })
  }

  const handleAddInstallment = () => {
    const baseDate = formState.deliveryDate || new Date().toISOString().slice(0, 10)
    setInstallments(prev => [
      ...prev,
      {
        numero: prev.length + 1,
        valor: 0,
        vencimento: baseDate,
        diasOffset: 0,
        comissaoAtiva: false,
      }
    ])
  }

  const handleRemoveInstallment = (index: number) => {
    setInstallments(prev => {
      const filtered = prev.filter((_, i) => i !== index)
      return filtered.map((item, idx) => ({ ...item, numero: idx + 1 }))
    })
  }

  const handleRefreshDueDates = () => {
    if (!formState.paymentCondition?.name) return
    const offsets = parseConditionToOffsets(formState.paymentCondition.name)
    const baseDate = formState.deliveryDate || new Date().toISOString().slice(0, 10)
    setInstallments(prev =>
      prev.map((inst, index) => {
        const offset = offsets[index] ?? offsets[offsets.length - 1] ?? 0
        return {
          ...inst,
          vencimento: addDays(baseDate, offset),
          diasOffset: offset,
        }
      })
    )
  }

  const sumInstallments = installments.reduce((acc, inst) => acc + Number(inst.valor || 0), 0)
  const totalItemsCost = addedProducts.reduce((sum, p) => sum + (p.subtotal || 0), 0)
  const shippingVal = Number(formState.shippingCost || 0) / 100
  const totalOrderAmount = totalItemsCost + shippingVal
  const hasMismatch = installments.length > 0 && Math.abs(sumInstallments - totalOrderAmount) > 0.01


  const uploadPendingFiles = useCallback(async (): Promise<number[]> => {
    if (selectedFiles.length === 0) return []
    const uploadedIds = await Promise.all(selectedFiles.map((file) => uploadFileToGeneralFiles(file)))
    setSelectedFiles([])
    return uploadedIds
  }, [selectedFiles])

  const buildPayload = useCallback(() => {
    const keptExistingIds = existingFileIds.filter((id) => !removedFileIds.includes(id))

    const grouped = new Map<string, ProductApiData>()
    addedProducts.forEach((p) => {
      const id = p.fashionProduct?.id || p.fashionProductId
      if (id === undefined) return
      const kitKey = p.kitIndex !== null && p.kitIndex !== undefined ? String(p.kitIndex) : 'null'
      const key = `${id}-${kitKey}`
      if (grouped.has(key)) {
        const ex = grouped.get(key)!
        ex.items = [...ex.items, ...p.items]
        ex.totalItems += p.totalItems || 0
        ex.subtotal += p.subtotal || 0
      } else {
        grouped.set(key, { ...p })
      }
    })

    const toDate = (d: string) => d ? `${d}T00:00:00.000Z` : undefined
    const deliveryDateVal = toDate(formState.deliveryDate)

    const payload: any = {
      clientId: formState.company?.id || undefined,
      supplierId: formState.supplier?.id || undefined,
      sellerId: formState.seller?.id || undefined,
      carrierId: formState.carrier?.id || undefined,
      orderTypeId: formState.orderTypeObj?.id || undefined,
      orderType: formState.orderType || 'Standard',
      billingDate: formState.billingDate ? `${formState.billingDate}T00:00:00.000Z` : undefined,
      clientOrderNumber: formState.clientOrderNumber ? Number(formState.clientOrderNumber) : undefined,
      representativeId: formState.representative?.id || undefined,
      orderSituationId: formState.orderSituation?.id || undefined,
      generalClassId: formState.generalClass?.id || undefined,
      sellingPrice: formState.sellingPrice ? centsDigitsToReais(formState.sellingPrice) : undefined,
      paymentConditionId: formState.paymentCondition?.id || undefined,
      shippingTypeId: formState.shippingType?.id || undefined,
      trackingCode: formState.trackingCode || undefined,
      shippingCost: centsDigitsToReais(formState.shippingCost) || undefined,
      totalCost: cleanCurrency(formState.totalCost) || undefined,
      total: cleanCurrency(formState.totalCost) || undefined,
      startDateOfDelivery: deliveryDateVal,
      finalDateOfDelivery: deliveryDateVal,
      orderDate: toDate(formState.orderDate) || new Date().toISOString(),
      extraInfo: formState.extraInformation || undefined,
      criticalAnalysis: formState.criticalAnalysis || undefined,
      criticalAnalysisDesc: formState.criticalAnalysisDesc || undefined,
      quantityItems: formState.quantityItems || undefined,
      quantityPieces: formState.quantityPieces || undefined,
      deliveryTime: formState.deliveryTime || undefined,
      maximumBillingAmount: formState.maximumBillingAmount || undefined,
      saleStatus: 'Em Orçamento',
      fileIds: keptExistingIds,
      items: Array.from(grouped.values()).map((p) => ({
        itemType: 'PRODUCT',
        productId: p.fashionProduct?.id || p.fashionProductId,
        quantity: p.totalItems ? Number(p.totalItems) : 0,
        descount: p.discount ? Number(p.discount) : 0,
        priceKg: p.subtotal ? Number(p.subtotal) : 0,
        sellingPrice: (p.sellingPrice !== undefined && p.sellingPrice !== null) ? Number(p.sellingPrice) : undefined,
        kitIndex: (p.kitIndex !== undefined && p.kitIndex !== null) ? p.kitIndex : undefined,
        extraInfo: JSON.stringify({
          fashionItems: p.items || [],
          colorCount: p.colorCount || 0,
          colors: p.colors || [],
          selectedColors: p.selectedColors || [],
          fashionProductName: p.fashionProduct?.name || p.name,
          fashionProductPrice: p.fashionProduct?.price || p.price,
          groupId: p.fashionProduct?.group?.id || p.group?.id,
          groupName: p.fashionProduct?.group?.name || p.group?.name,
          familyId: p.fashionProduct?.group?.family?.id || p.family?.id,
          familyName: p.fashionProduct?.group?.family?.name || p.family?.name,
          collectionId: p.fashionProduct?.group?.family?.collectionId,
        }),
      })),
      paymentMethods: selectedPaymentMethodId ? [{ paymentMethodId: selectedPaymentMethodId }] : [],
      installments: installments.map(i => ({
        numero: i.numero,
        valor: i.valor,
        vencimento: i.vencimento,
        diasOffset: i.diasOffset || undefined,
        comissaoAtiva: i.comissaoAtiva || undefined,
      })),
    }

    return payload
  }, [formState, addedProducts, existingFileIds, removedFileIds, selectedPaymentMethodId, installments])

  const withSaving = useCallback(
    async (fn: () => Promise<void>) => {
      outletContext?.setIsSaving?.(true)
      try { await fn() } finally { outletContext?.setIsSaving?.(false) }
    },
    [outletContext]
  )

  const handleSaveOrder = useCallback(async () => {
    if (addedProducts.length === 0) {
      setFeedback({
        isOpen: true,
        message: 'O pedido deve ter pelo menos um item.',
        statusOk: false,
      })
      throw new Error('O pedido deve ter pelo menos um item')
    }
    try {
      await withSaving(async () => {
        const payload = buildPayload()
        const response = await axios.post(`${ORDERS_URL}/order`, payload)
        const createdOrderId = response.data?.id
        if (selectedFiles.length > 0 && createdOrderId) {
          const newFileIds = await uploadPendingFiles()
          const keptExistingIds = existingFileIds.filter((id) => !removedFileIds.includes(id))
          const allFileIds = [...keptExistingIds, ...newFileIds]
          await axios.patch(`${ORDERS_URL}/order/${createdOrderId}`, {
            fileIds: allFileIds
          })
        } else {
          setSelectedFiles([])
        }
        setFeedback({ isOpen: true, message: 'Pedido criado com sucesso!', statusOk: true })
      })
    } catch (err: any) {
      setFeedback({
        isOpen: true,
        message: `Erro ao salvar pedido: ${err.response?.data?.message || err.message}`,
        statusOk: false,
      })
      throw err
    }
  }, [buildPayload, uploadPendingFiles, selectedFiles, existingFileIds, removedFileIds, setFeedback, withSaving, addedProducts])

  const handleEditSaveOrder = useCallback(async () => {
    if (addedProducts.length === 0) {
      setFeedback({
        isOpen: true,
        message: 'O pedido deve ter pelo menos um item.',
        statusOk: false,
      })
      throw new Error('O pedido deve ter pelo menos um item')
    }
    try {
      await withSaving(async () => {
        const payload = buildPayload()
        await axios.patch(`${ORDERS_URL}/order/${orderId}`, payload)
        if (selectedFiles.length > 0) {
          const newFileIds = await uploadPendingFiles()
          const keptExistingIds = existingFileIds.filter((id) => !removedFileIds.includes(id))
          const allFileIds = [...keptExistingIds, ...newFileIds]
          await axios.patch(`${ORDERS_URL}/order/${orderId}`, {
            fileIds: allFileIds
          })
        } else {
          setSelectedFiles([])
        }
        setFeedback({ isOpen: true, message: 'Pedido atualizado com sucesso!', statusOk: true })
      })
    } catch (err: any) {
      setFeedback({ isOpen: true, message: 'Erro ao atualizar o pedido', statusOk: false })
      throw err
    }
  }, [buildPayload, orderId, uploadPendingFiles, selectedFiles, existingFileIds, removedFileIds, setFeedback, withSaving, addedProducts])

  useEffect(() => {
    if (!isEditing && outletContext?.handleSave)
      outletContext.handleSave.current = handleSaveOrder
  }, [handleSaveOrder, outletContext, isEditing])

  useEffect(() => {
    if (isEditing && outletContext?.handleEditSave)
      outletContext.handleEditSave.current = handleEditSaveOrder
  }, [handleEditSaveOrder, outletContext, isEditing])

  const closeProductEdit = () => {
    if (typeof showAddProductForSection === 'number') {
      const currentKitIdx = showAddProductForSection;

      const hasProductsInKit = addedProducts.some(
        (p) => p.kitIndex === currentKitIdx
      );

      if (!hasProductsInKit) {
        setKitCount((prev) => Math.max(0, prev - 1));
      }
    }


    setEditingProductIndex(null);
    setProductToEdit(null);
    setOpenProductIndex(null);
    setShowAddProductForSection(null);
  };

  const handleRemoveProduct = (index: number) => {
    setAddedProducts((prev) => prev.filter((_, i) => i !== index))
    closeProductEdit()
  }

  const handleProductUpdated = (_: ProductApiData, updated: ProductApiData) => {
    const idx = editingProductIndex ?? openProductIndex
    if (idx === null) return
    setAddedProducts((prev) => {
      const next = [...prev]
      next[idx] = normalizeProductData({ ...updated, kitIndex: prev[idx].kitIndex })
      return next
    })
    closeProductEdit()
  }

  const handleNewProductAdded = (newProduct: ProductApiData) => {
    if (newProduct.isKitIntent) {
      if (!newProduct.fashionProductId) {
        if (showAddProductForSection === 'standalone') {
          const nextKitIdx = kitCount;
          setKitCount(prev => prev + 1);
          setShowAddProductForSection(nextKitIdx);
        }
        else {
          setShowAddProductForSection(null);
        }
        return;
      }


      if (showAddProductForSection === 'standalone') {
        const newIdx = kitCount;
        setKitCount((prev) => prev + 1);

        setAddedProducts((prev) => [
          ...prev,
          normalizeProductData({ ...newProduct, kitIndex: newIdx })
        ]);

        setShowAddProductForSection(null);
        return;
      }

      const targetKitIdx = typeof showAddProductForSection === 'number'
        ? showAddProductForSection
        : kitCount - 1;

      setAddedProducts((prev) => [
        ...prev,
        normalizeProductData({ ...newProduct, kitIndex: targetKitIdx })
      ]);

      setShowAddProductForSection(null);
    } else {
      setAddedProducts((prev) => [
        ...prev,
        normalizeProductData({ ...newProduct, kitIndex: null })
      ]);
      setShowAddProductForSection(null);
    }
  };

  const handleRemoveKit = (kitIdx: number) => {
    setAddedProducts((prev) =>
      prev
        .filter((p) => p.kitIndex !== kitIdx)
        .map((p) => {
          if (p.kitIndex !== null && p.kitIndex !== undefined && p.kitIndex > kitIdx)
            return { ...p, kitIndex: p.kitIndex - 1 }
          return p
        })
    )
    setKitCount((prev) => prev - 1)
    closeProductEdit()
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []).filter((f) => {
      if (f.size > FILE_SIZE_LIMIT) { alert(`Arquivo ${f.name} excede 200MB.`); return false }
      return true
    })
    setSelectedFiles((prev) => [...prev, ...files])
    e.target.value = ''
  }

  const handleRemoveFile = (i: number) =>
    setSelectedFiles((prev) => prev.filter((_, idx) => idx !== i))

  const handlePreviewFile = useCallback((file: File) => {
    const url = URL.createObjectURL(file)
    window.open(url, '_blank')
    setTimeout(() => URL.revokeObjectURL(url), 10_000)
  }, [])

  const handleDownloadFile = useCallback((file: File) => {
    const url = URL.createObjectURL(file)
    void downloadRemoteFile(url, file.name).finally(() => URL.revokeObjectURL(url))
  }, [])

  const handleRemoveExistingAttachment = (id: number) => {
    if (window.confirm('Tem certeza que deseja remover este anexo?')) {
      setExistingAttachments((prev) => prev.filter((a) => a.id !== id))
      setRemovedFileIds((prev) => [...prev, id])
    }
  }

  const handleViewAttachment = (a: ExistingAttachment) => {
    if (a.filePath) window.open(a.filePath, '_blank')
  }

  const handleDownloadAttachment = (a: ExistingAttachment) => {
    if (!a.filePath) return
    void downloadRemoteFile(a.filePath, a.originalName)
  }

  const renderInfoPanel = (
    isOpen: boolean,
    toggle: () => void,
    fields: { label: string; value: string }[]
  ) => (
    <InfoLink>
      <Info size={14} /> 
      <InfoPopoverWrapper>
        <span onClick={toggle}>Mais informações</span>
        {isOpen && (
          <MoreInformation>
            {fields.map(({ label, value }) => (
              <InfoName key={label}>{label}: <InfoValue>{value}</InfoValue></InfoName>
            ))}
          </MoreInformation>
        )}
      </InfoPopoverWrapper>
    </InfoLink>
  )

  const renderOptionSelect = (
    label: string,
    field: string,
    options: string[]
  ) => (
    <FormGroup>
      <Label>{label}</Label>
      <Select value={(formState as any)[field]} onChange={(e) => setField(field, e.target.value)}>
        <option value=''>Selecione</option>
        {options.map((opt) => <option key={opt} value={opt}>{opt}</option>)}
      </Select>
    </FormGroup>
  )

  const renderProductCard = (product: ProductApiData, index: number, isInsideKit: boolean = false) => {
    const totalPieces = product.sizeQuantities
      ? Object.values(product.sizeQuantities).reduce((s, q) => s + q, 0)
      : product.totalItems ?? 0

    const clampedDiscount = Math.min(100, Math.max(0, product.discount ?? 0))
    const discountDisplay = (): string => {
      if (!clampedDiscount || clampedDiscount <= 0) return '-'
      if (product.discountValue !== undefined) return formatCurrency(product.discountValue)
      const original = (product.subtotal || 0) / (1 - clampedDiscount / 100)
      return formatCurrency((original * clampedDiscount) / 100)
    }

    const fields = [
      { label: 'Produto', value: product.fashionProduct?.name ?? '-' },
      { label: 'Família', value: product.fashionProduct?.group?.family?.name || product.family?.name || '-' },
      { label: 'Cores', value: countColors(product) },
      {
        label: 'Precificação',
        value: typeof product.fashionProduct?.price === 'number'
          ? formatCurrency(product.fashionProduct.price) : '-',
      },
      { label: 'Quantidade de peças', value: totalPieces },
      { label: 'Desconto', value: discountDisplay() },
      {
        label: 'Subtotal',
        value: typeof product.subtotal === 'number' ? formatCurrency(product.subtotal) : '-',
      },
    ]


    const CardComponent = isInsideKit ? SubProductCard : Card

    return (
      <CardComponent key={`${product.fashionProductId}-${index}`}>
        <ProductShort>
          <CardProductDiv>
            <ProductFieldsRow>
              {fields.map(({ label, value }, i) => (
                <ShortLabel key={i}>
                  <ShortLabelText>{label}:</ShortLabelText>&nbsp;
                  {getSafeValue(value)}
                </ShortLabel>
              ))}
            </ProductFieldsRow>
            <CardActionsDiv>
              <RoundTrashButton type="button" onClick={() => handleRemoveProduct(index)}>
                <Trash2 size={16} />
              </RoundTrashButton>
              <RoundCollapseButton
                type="button"
                isOpen={openProductIndex === index}
                onClick={() => setOpenProductIndex(openProductIndex === index ? null : index)}
              >
                <ChevronDown size={16} />
              </RoundCollapseButton>
            </CardActionsDiv>
          </CardProductDiv>
        </ProductShort>

        {openProductIndex === index && (
          <div style={{ marginTop: '16px', borderTop: '1px solid #EBEBEB', paddingTop: '16px' }}>
            <AddProductForm
              order={addedProducts}
              setOrder={setAddedProducts}
              product={product}
              isEditing={true}
              onProductAdded={handleNewProductAdded}
              onProductUpdated={handleProductUpdated}
              onRemoveProduct={handleRemoveProduct}
              onClose={() => setOpenProductIndex(null)}
              isKitMode={isInsideKit}
              setIsKitMode={setIsKitMode}
            />
          </div>
        )}
      </CardComponent>
    )
  }

  const renderSectionAddProduct = (section: 'standalone' | number) => {
    const isThisSectionOpen = showAddProductForSection === section
    const isEditing_ = editingProductIndex !== null

    return (
      <AddProductContainer>
        {isThisSectionOpen && (
          <AddProductForm
            order={addedProducts}
            setOrder={setAddedProducts}
            product={productToEdit}
            isEditing={isEditing_}
            onProductAdded={!isEditing_ ? handleNewProductAdded : undefined}
            onProductUpdated={isEditing_ ? handleProductUpdated : undefined}
            onRemoveProduct={handleRemoveProduct}
            onClose={closeProductEdit}
            isKitMode={isKitMode}
            setIsKitMode={setIsKitMode}
          />
        )}
        {/* <AddButton onClick={() => {
          setProductToEdit(null)
          setEditingProductIndex(null)
          setOpenProductIndex(null)
          setShowAddProductForSection(section)
        }}>
          <AddButtonImg src={plus} />
          <AddButtonText>Adicionar produto</AddButtonText>
        </AddButton> */}
      </AddProductContainer>
    )
  }

  if (loading) return <div>Carregando...</div>

  const standaloneProducts = addedProducts
    .map((p, i) => ({ product: p, index: i }))
    .filter(({ product }) => product.kitIndex === null || product.kitIndex === undefined)

  const kitProducts = (kitIdx: number) =>
    addedProducts
      .map((p, i) => ({ product: p, index: i }))
      .filter(({ product }) => product.kitIndex === kitIdx)

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <Card>
        <FormGrid>
          <FormGroup>
            <CompanySelect
              label='Meu cnpj'
              apiUrl={`${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/companies`}
              displayField='companyName'
              queryParams={{ isMain: 'true' }}
              value={formState.supplier}
              onChange={(v) => setField('supplier', v)}
            />
            {renderInfoPanel(
              isInformationOpen && formState.supplier.id > 0,
              () => setIsInformationOpen((v) => !v),
              [
                { label: 'Razão Social', value: (formState.supplier as any).companyName || 'N/A' },
                { label: 'CNPJ/CPF', value: (formState.supplier as any).cnpj || (formState.supplier as any).cpf || 'N/A' },
                { label: 'Cidade/UF', value: `${(formState.supplier as any).city?.name || 'N/A'}/${(formState.supplier as any).state?.name || 'N/A'}` },
                { label: 'Telefone', value: (formState.supplier as any).phone || (formState.supplier as any).telefone || (formState.supplier as any).contacts?.[0]?.phone || (formState.supplier as any).contacts?.[0]?.phoneNumber || 'N/A' },
                { label: 'Email', value: (formState.supplier as any).email || (formState.supplier as any).contacts?.[0]?.email || 'N/A' },
              ]
            )}
          </FormGroup>

          <FormGroup>
            <VendorSelect
              label='Vendedor'
              apiUrl={`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/user/findAll?filters=${encodeURIComponent(JSON.stringify([{ field: 'Perfil', type: 'Contém', text: 'VENDEDOR' }]))}`}
              displayField='name'
              value={formState.seller}
              onChange={(v) => setField('seller', v)}
            />
            {renderInfoPanel(
              isSellerInfoOpen && formState.seller.id > 0,
              () => setIsSellerInfoOpen((v) => !v),
              [
                 { label: 'Nome', value: (formState.seller as any).name || 'N/A' },
                { label: 'Email', value: (formState.seller as any).email || 'N/A' },
                { label: 'Perfil', value: (formState.seller as any).Profile?.name || (formState.seller as any).profile?.name || (Number((formState.seller as any).profileId) === 3 ? 'Admin' : Number((formState.seller as any).profileId) === 2 ? 'Vendedor' : ((formState.seller as any).role === 'TENANT_ADMIN' ? 'Admin' : (formState.seller as any).role === 'TENANT_USER' ? 'Vendedor' : 'N/A')) },
              ]
            )}
          </FormGroup>

          <FormGroup>
            <CompanySelect
              label='Cliente'
              apiUrl={`${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/companies`}
              displayField='companyName'
              queryParams={{ companyType: 'Cliente', excludeMainCompany: 'true' }}
              value={formState.company}
              onChange={(v) => setField('company', v)}
              allowCreate={true}
            />
            {renderInfoPanel(
              isClientInformationOpen && formState.company.id > 0,
              () => setIsClientInformationOpen((v) => !v),
              [
                { label: 'Razão Social', value: (formState.company as any).companyName || 'N/A' },
                { label: 'CNPJ/CPF', value: (formState.company as any).cnpj || (formState.company as any).cpf || 'N/A' },
                { label: 'Cidade/UF', value: `${(formState.company as any).city?.name || 'N/A'}/${(formState.company as any).state?.name || 'N/A'}` },
                { label: 'Telefone', value: (formState.company as any).phone || (formState.company as any).telefone || (formState.company as any).contacts?.[0]?.phone || (formState.company as any).contacts?.[0]?.phoneNumber || 'N/A' },
                { label: 'Email', value: (formState.company as any).email || (formState.company as any).contacts?.[0]?.email || 'N/A' },
              ]
            )}
          </FormGroup>
        </FormGrid>

        <Separator />

        <CollapsibleHeader onClick={() => setIsDetailsOpen((v) => !v)}>
          <Title>Detalhes do pedido</Title>
          <CircularCollapseIcon>
            {isDetailsOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </CircularCollapseIcon>
        </CollapsibleHeader>

        {isDetailsOpen && (
          <>
            <FormGrid className="mt" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
              <FormGroup>
                <InfiniteSelect
                  mode="crud"
                  allowDelete={true}
                  getOptionLabel={(opt: any) => opt.name}
                  label="Tipo de Pedido"
                  placeholder="Selecione um tipo de pedido..."
                  value={formState.orderTypeObj}
                  fetchFunction={fetchOrderTypes}
                  onItemCreate={createOrderTypeOption}
                  onItemDelete={deleteOrderTypeOption}
                  onSelect={(option: any) => {
                    setFormState(prev => ({
                      ...prev,
                      orderTypeObj: option,
                      orderType: option?.name ?? ''
                    }))
                  }}
                />
              </FormGroup>

              <FormGroup>
                <InfiniteSelect
                  mode="crud"
                  allowDelete={true}
                  getOptionLabel={(opt: any) => opt.name}
                  label="Representante"
                  placeholder="Selecione um representante..."
                  value={formState.representative}
                  fetchFunction={fetchRepresentatives}
                  onItemCreate={createRepresentativeOption}
                  onItemDelete={deleteRepresentativeOption}
                  onSelect={(option: any) => setField('representative', option)}
                />
              </FormGroup>

              <FormGroup>
                <InfiniteSelect
                  mode="crud"
                  allowDelete={true}
                  getOptionLabel={(opt: any) => opt.name}
                  label="Situação do Pedido"
                  placeholder="Selecione uma situação..."
                  value={formState.orderSituation}
                  fetchFunction={fetchOrderSituations}
                  onItemCreate={createOrderSituationOption}
                  onItemDelete={deleteOrderSituationOption}
                  onSelect={(option: any) => setField('orderSituation', option)}
                />
              </FormGroup>
            </FormGrid>

            <FormGrid style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginTop: '16px' }}>
              <FormGroup>
                <InfiniteSelect
                  mode="crud"
                  allowDelete={true}
                  getOptionLabel={(opt: any) => opt.name}
                  label="Classe Geral"
                  placeholder="Selecione uma classe geral..."
                  value={formState.generalClass}
                  fetchFunction={fetchGeneralClasses}
                  onItemCreate={createGeneralClassOption}
                  onItemDelete={deleteGeneralClassOption}
                  onSelect={(option: any) => setField('generalClass', option)}
                />
              </FormGroup>

              <FormGroup>
                <Label>Data do Pedido</Label>
                <InputText className="inline-date" type="date" max="9999-12-31" value={formState.orderDate}
                  onChange={(e) => setField('orderDate', e.target.value)} />
              </FormGroup>

              <FormGroup>
                <Label>Prazo de Entrega</Label>
                <InputText className="inline-date" type="date" max="9999-12-31" value={formState.deliveryDate}
                  onChange={(e) => setField('deliveryDate', e.target.value)} />
              </FormGroup>
            </FormGrid>

            <FormGrid style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginTop: '16px', marginBottom: '16px' }}>
              <FormGroup>
                <Label>Data de Faturamento</Label>
                <InputText className="inline-date" type="date" max="9999-12-31" value={formState.billingDate}
                  onChange={(e) => setField('billingDate', e.target.value)} />
              </FormGroup>

              <FormGroup>
                <Label>Nº do Pedido do Cliente</Label>
                <InputText className="inline-input" type="number" placeholder="Digite o número" value={formState.clientOrderNumber}
                  onChange={(e) => setField('clientOrderNumber', e.target.value)} />
              </FormGroup>

              <FormGroup>
                <Label>Preço de Venda do Pedido</Label>
                <InputText
                  className="inline-input"
                  type="text"
                  placeholder="R$ 0,00"
                  value={formState.sellingPrice ? formatCentDigitsForInput(formState.sellingPrice) : ''}
                  onChange={(e) => setField('sellingPrice', e.target.value.replace(/\D/g, '').slice(0, 12))}
                />
              </FormGroup>
            </FormGrid>

            <FormGrid>
              <FormGroup>
                <Label>Anexos</Label>
                <AttachmentManager
                  selectedFiles={selectedFiles}
                  existingAttachments={existingAttachments}
                  onFileChange={handleFileChange}
                  onRemoveFile={handleRemoveFile}
                  onViewAttachment={handleViewAttachment}
                  onDownloadAttachment={handleDownloadAttachment}
                  onRemoveExistingAttachment={isEditing ? handleRemoveExistingAttachment : undefined}
                  formatFileSize={formatFileSize}
                  onPreviewFile={handlePreviewFile}
                  onDownloadFile={handleDownloadFile}
                />
              </FormGroup>
              <FormGroup>
                <Label>Informação extra</Label>
                <InputText className="inline-input" type="text" placeholder="Digite" value={formState.extraInformation}
                  onChange={(e) => setField('extraInformation', e.target.value)} />
              </FormGroup>
            </FormGrid>

            <FormGrid>
              <FormGroup style={{ alignItems: 'flex-start' }}>
                <Label>Análise Crítica</Label>
                <SwitchBox>
                  <SwitchInput
                    type="checkbox"
                    checked={formState.criticalAnalysis}
                    onChange={(e) => setField('criticalAnalysis', e.target.checked)}
                  />
                  <SwitchSlider className="slider"></SwitchSlider>
                </SwitchBox>
              </FormGroup>
              <FormGroup style={{ flex: 2 }}>
                <Label>Descrição da Análise</Label>
                <Textarea
                  placeholder="Digite a descrição da análise"
                  value={formState.criticalAnalysisDesc}
                  onChange={(e) => setField('criticalAnalysisDesc', e.target.value)}
                />
              </FormGroup>
            </FormGrid>
          </>
        )}

        <Separator />

        <Summary>
          <SummaryItem>
            <SummaryLabel>Quantidade de conjuntos:</SummaryLabel>
            <SummaryValue>{kitCount}</SummaryValue>
          </SummaryItem>
          <SummaryItem>
            <SummaryLabel>Quantidade de itens:</SummaryLabel>
            <SummaryValue>{formState.quantityItems}</SummaryValue>
          </SummaryItem>
          <SummaryItem>
            <SummaryLabel>Quantidade de peças:</SummaryLabel>
            <SummaryValue>{formState.quantityPieces}</SummaryValue>
          </SummaryItem>
          <SummaryItem>
            <SummaryLabel>Total:</SummaryLabel>
            <SummaryValue>{formState.totalCost}</SummaryValue>
          </SummaryItem>
        </Summary>
      </Card>

      <Card>
        <CollapsibleHeader onClick={() => setIsShippingSectionOpen((v) => !v)}>
          <Title>Frete</Title>
          <CircularCollapseIcon>
            {isShippingSectionOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </CircularCollapseIcon>
        </CollapsibleHeader>

        {isShippingSectionOpen && (
          <FormGrid className="mt">
            <FormGroup>
              <InfiniteSelect
                label="Tipo de frete"
                placeholder="Selecione o tipo de frete"
                mode="crud"
                endpointConfig={{
                  baseUrl: `${process.env.REACT_APP_GATEWAY_BASE_URL}/steel-orders/select-in-order`,
                  listPath: '/shipping-types',
                  createPath: '/shipping-types',
                  deletePath: '/shipping-types',
                  offsetParam: 'page',
                  transformResponse: (data: any) => data?.data || [],
                }}
                value={formState.shippingType as any}
                onSelect={(val) => setField('shippingType', val)}
              />
            </FormGroup>

            <FormGroup>
              <Label>Valor do frete</Label>
              <InputText className="inline-input" type='text' placeholder='Digite o valor do frete'
                value={formatCentDigitsForInput(formState.shippingCost)}
                onChange={(e) => setField('shippingCost', e.target.value.replace(/\D/g, '').slice(0, 12))} />
            </FormGroup>

            <FormGroup>
              <CompanySelect
                label='Transportadora'
                apiUrl={`${process.env.REACT_APP_GATEWAY_BASE_URL}/companies/companies`}
                displayField='companyName'
                queryParams={{ companyType: 'Transportadora', excludeMainCompany: 'true' }}
                value={formState.carrier}
                onChange={(v) => setField('carrier', v)}
              />
            </FormGroup>

            <FormGroup>
              <Label>Código de rastreio</Label>
              <InputText className="inline-input" type='text' placeholder='Digite o código de rastreio'
                value={formState.trackingCode}
                onChange={(e) => setField('trackingCode', e.target.value)} />
            </FormGroup>
          </FormGrid>
        )}
      </Card>

      <Card>
        <CollapsibleHeader onClick={() => setIsPaymentSectionOpen((v) => !v)}>
          <Title>Pagamento</Title>
          <CircularCollapseIcon>
            {isPaymentSectionOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </CircularCollapseIcon>
        </CollapsibleHeader>

        {isPaymentSectionOpen && (
          <>
            <FormGrid className="mt">
              <FormGroup>
                <InfiniteSelect
                  label="Condição de pagamento"
                  placeholder="Selecione a condição"
                  mode="crud"
                  endpointConfig={{
                    baseUrl: `${process.env.REACT_APP_GATEWAY_BASE_URL}/steel-orders/select-in-order`,
                    listPath: '/payment-conditions',
                    createPath: '/payment-conditions',
                    deletePath: '/payment-conditions',
                    offsetParam: 'page',
                    transformResponse: (data: any) => data?.data || [],
                  }}
                  value={formState.paymentCondition as any}
                  onSelect={(val) => setField('paymentCondition', val)}
                />
              </FormGroup>

              <FormGroup>
                <Label>Forma de pagamento</Label>
                <Select
                  className="inline-input"
                  value={selectedPaymentMethodId ?? ''}
                  onChange={(e) => setSelectedPaymentMethodId(e.target.value ? Number(e.target.value) : null)}
                >
                  <option value="">Selecione</option>
                  {paymentMethods.map((method) => (
                    <option key={method.id} value={method.id}>
                      {paymentMethodLabel(method.name)}
                    </option>
                  ))}
                </Select>
              </FormGroup>
            </FormGrid>

            <Separator />

            <SectionHeader>
              <Title style={{ fontSize: '14px' }}>Parcelas</Title>
              <Button
                type="button"
                onClick={handleRefreshDueDates}
                style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 12px', fontSize: '12px' }}
              >
                <RefreshCw size={12} /> Atualizar data
              </Button>
            </SectionHeader>

            {installments.length === 0 ? (
              <EmptyMessage style={{ margin: '16px 0' }}>
                Selecione uma condição de pagamento ou adicione parcelas manualmente.
              </EmptyMessage>
            ) : (
              <InstallmentsTable style={{ marginTop: '16px' }}>
                <HeaderRow>
                  <span style={{ textAlign: 'center', fontSize: '12px' }}>Nº</span>
                  <span style={{ fontSize: '12px' }}>Valor</span>
                  <span style={{ fontSize: '12px' }}>Vencimento</span>
                  <span style={{ fontSize: '12px' }}>Ações</span>
                </HeaderRow>

                {installments.map((inst, index) => (
                  <InstallmentRow key={index}>
                    <NumberCell>{inst.numero}</NumberCell>
                    <div>
                      <InputText
                        className="inline-input"
                        type="text"
                        placeholder="R$ 0,00"
                        value={formatCentDigitsForInput(String(Math.round(Number(inst.valor || 0) * 100)))}
                        onChange={(e) => {
                          const digits = e.target.value.replace(/\D/g, '');
                          const centsVal = digits ? Number(digits) / 100 : 0;
                          handleUpdateInstallment(index, { valor: centsVal });
                        }}
                      />
                    </div>
                    <div>
                      <InputText
                        className="inline-date"
                        type="date"
                        max="9999-12-31"
                        value={inst.vencimento}
                        onChange={(e) => {
                          handleUpdateInstallment(index, { vencimento: e.target.value });
                        }}
                      />
                    </div>
                    <div>
                      <RemoveButton type="button" onClick={() => handleRemoveInstallment(index)}>
                        <Trash2 size={16} />
                      </RemoveButton>
                    </div>
                  </InstallmentRow>
                ))}
              </InstallmentsTable>
            )}

            {hasMismatch && (
              <SummaryLine mismatch style={{ marginTop: '16px' }}>
                A soma das parcelas ({formatCurrency(sumInstallments)}) não corresponde ao total do pedido ({formatCurrency(totalOrderAmount)})
              </SummaryLine>
            )}

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px', marginBottom: '16px' }}>
              <Button
                type="button"
                onClick={handleAddInstallment}
                style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 16px' }}
              >
                <Plus size={14} /> Adicionar parcela
              </Button>
            </div>
          </>
        )}
      </Card>

      <Card>
        <CollapsibleHeader onClick={() => setIsItemsSectionOpen((v) => !v)}>
          <Title>Itens do pedido</Title>
          <CircularCollapseIcon>
            {isItemsSectionOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </CircularCollapseIcon>
        </CollapsibleHeader>

        {isItemsSectionOpen && (
          <>
            <ItemsListContainer>
              {standaloneProducts.map(({ product, index }) => renderProductCard(product, index))}

              {Array.from({ length: kitCount }, (_, kitIdx) => {
                const kits = kitProducts(kitIdx)

                const kitTotalItems = kits.length
                const kitTotalPieces = kits.reduce((sum, { product }) => {
                  const pieces = product.sizeQuantities
                    ? Object.values(product.sizeQuantities).reduce((s, q) => s + q, 0)
                    : product.totalItems || 0
                  return sum + pieces
                }, 0)
                const kitTotal = kits.reduce((sum, { product }) => sum + (product.subtotal || 0), 0)
                const isKitOpen = openKits[kitIdx] !== false;

                return (
                  <KitContainer key={`kit-section-${kitIdx}`}>
                    <KitHeader>
                      <KitSummaryRow>
                        <Summary>
                          <SummaryItem>
                            <KitSummaryLabel>Conjunto {kitIdx + 1}</KitSummaryLabel>
                          </SummaryItem>
                          <SummaryItem>
                            <SummaryLabel>Quantidade de itens:</SummaryLabel>
                            <SummaryValue>{kitTotalItems}</SummaryValue>
                          </SummaryItem>
                          <SummaryItem>
                            <SummaryLabel>Quantidade de peças:</SummaryLabel>
                            <SummaryValue>{kitTotalPieces}</SummaryValue>
                          </SummaryItem>
                          <SummaryItem>
                            <SummaryLabel>Total:</SummaryLabel>
                            <SummaryValue>{formatCurrency(kitTotal)}</SummaryValue>
                          </SummaryItem>
                        </Summary>
                        <ActionsDiv style={{ gap: '8px' }}>
                          <RoundTrashButton
                            type="button"
                            onClick={() => handleRemoveKit(kitIdx)}
                          >
                            <Trash2 size={16} />
                          </RoundTrashButton>
                          <RoundCollapseButton
                            type="button"
                            isOpen={isKitOpen}
                            onClick={() => setOpenKits((prev) => ({ ...prev, [kitIdx]: !isKitOpen }))}
                          >
                            <ChevronDown size={16} />
                          </RoundCollapseButton>
                        </ActionsDiv>
                      </KitSummaryRow>
                    </KitHeader>

                    {isKitOpen && (
                      <>
                        {kits.map(({ product, index }) => renderProductCard(product, index, true))}

                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '12px' }}>
                          <ActionOutlineButton type="button" onClick={() => {
                            setProductToEdit(null);
                            setEditingProductIndex(null);
                            setOpenProductIndex(null);
                            setShowAddProductForSection(kitIdx);
                            setIsKitMode(true);
                          }}>
                            <Plus size={16} /> Adicionar Item ao Conjunto
                          </ActionOutlineButton>
                        </div>
                      </>
                    )}
                  </KitContainer>
                )
              })}
            </ItemsListContainer>

            <CenteredButtonsRow>
        <ActionOutlineButton type="button" onClick={() => {
          setProductToEdit(null)
          setEditingProductIndex(null)
          setOpenProductIndex(null)
          setShowAddProductForSection('standalone')
        }}>
          <Plus size={16} /> Adicionar Novo Item
        </ActionOutlineButton>

        <ActionSolidButton type="button" onClick={() => {
          setKitCount((prev) => prev + 1)
          closeProductEdit()
        }}>
          <Plus size={16} /> Adicionar Conjunto
        </ActionSolidButton>
      </CenteredButtonsRow>

          </>
        )}
      </Card>
    </div>

    {showAddProductForSection !== null && (
      <ModalOverlay onClick={closeProductEdit}>
        <ModalWrapper onClick={(e) => e.stopPropagation()}>
          <AddProductForm
            order={addedProducts}
            setOrder={setAddedProducts}
            product={productToEdit}
            isEditing={editingProductIndex !== null}
            onProductAdded={editingProductIndex === null ? handleNewProductAdded : undefined}
            onProductUpdated={editingProductIndex !== null ? handleProductUpdated : undefined}
            onRemoveProduct={handleRemoveProduct}
            onClose={closeProductEdit}
            isKitMode={showAddProductForSection !== 'standalone'}
            setIsKitMode={setIsKitMode}
          />
        </ModalWrapper>
      </ModalOverlay>
    )}
    </>
  )
}

export default RegisterFashionOrder